import currency from 'currency.js'
import { moneyToNumber } from 'xmgoing-utils';
import { usePageModelsStore } from "@/store/modules/pageModels";
import {
  resolveConfiguredPricePrecision,
  toUnconfiguredPriceString,
} from '@/main-page-form/ctls/baseCtls/FloatNumber/precisionConfigUtils';

const numberShowTypeMap = {
  numberOne: 1,
  numberTwo: 2,
  numberThree: 3,
  numberFour: 4,
  numberFive: 5,
}


export function moneyFormat(number) {
  if (number === null || number === undefined || number === '') {
    return '';
  }
  const numStr = number.toString();
  // 分割整数和小数部分，只对整数部分进行千分位格式化
  const parts = numStr.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join('.');
}

export function noMoneyFormat(str){
  if(str&&(str+"").length>0){
    str=(str+"").replace(/,/g,"");
  }
  return str;
}

/**
 * 获取金额值。未配精度按 6 位封顶、不补 0。
 */
export function getNumberPrice(val, numberShowType = null) {
  if (isNaN(parseFloat(val + ''))) {
    val = 0;
  }
  const showType = unref(numberShowType);
  if (showType == null || showType === '' || showType === 'number') {
    return toUnconfiguredPriceString(val);
  }
  if (showType in numberShowTypeMap) {
    return currency(val, {
      precision: numberShowTypeMap[showType],
      symbol: '',
      separator: ''
    }).format()
  }

  if (typeof showType === 'number' && Number.isInteger(showType) && showType >= 0) {
    return currency(val, {
      precision: showType,
      symbol: '',
      separator: ''
    }).format()
  }

  return toUnconfiguredPriceString(val);
}


/**
 * 获取已配精度；未配时返回 null（走 6 位封顶、不补 0）。
 */
export function getPrecision(props: any): number | null {
  const pageModelsStore = usePageModelsStore();
  return resolveConfiguredPricePrecision(unref(props), pageModelsStore.state['bopConfig']);
}

export function usePriceCtl({pModelObj, model,props},ctlType='xmPrice') {
  const dateVal: any = ref('');
  const startDataVal:any = ref('');
  const endDataVal:any = ref('');

  const change = ref(false);
  // 获取精度值
  const precision = getPrecision(props);
  // 如果存在默认值 则进行赋值操作
  if (unref(model)&&unref(pModelObj)&&unref(model)&&unref(pModelObj)[unref(model).key]) {
    change.value = true;
    dateVal.value=getNumberPrice(unref(pModelObj)[unref(model).key]||0,precision);
   if(ctlType==='xmPriceRange'){
     startDataVal.value=getNumberPrice(unref(pModelObj)[unref(model).key+"_ge"]||0,precision);
     endDataVal.value=getNumberPrice(unref(pModelObj)[unref(model).key+"_le"]||0,precision);
   }
    nextTick(() => {
      change.value = false;
    })
  }

  //获取焦点
  const focusVal=function (){
    dateVal.value=noMoneyFormat(dateVal.value);
    if(parseFloat(dateVal.value)-0===0){
      dateVal.value='';
    }
    if(ctlType==='xmPriceRange'){
      startDataVal.value=noMoneyFormat(startDataVal.value);
    }
    if(dateVal.value==="0"||dateVal.value===0){
      dateVal.value="";
      change.value = true;
      nextTick(()=>{
        change.value=false;
      })
    }
  }

  const focusEndVal=function (){
    dateVal.value=noMoneyFormat(dateVal.value);
    if(ctlType==='xmPriceRange'){
      endDataVal.value=noMoneyFormat(endDataVal.value);
    }
    if(dateVal.value==="0"||dateVal.value===0){
      dateVal.value="";
      change.value = true;
      nextTick(()=>{
        change.value=false;
      })
    }
  }

  //失去焦点
  const blurVal=function (){
    //如果不是正确数字 则提示
    if(isNaN(parseFloat(dateVal.value))){
      dateVal.value=0;
      return
    }
    dateVal.value=parseFloat(dateVal.value);

    // 超出范围时，限制在允许范围内
    const min = unref(props)?.min;
    const max = unref(props)?.max;
    if (min !== undefined && min !== null && dateVal.value < min) {
      dateVal.value = min;
    }
    if (max !== undefined && max !== null && dateVal.value > max) {
      dateVal.value = max;
    }

    dateVal.value=getNumberPrice(dateVal.value,precision);
    if(ctlType==='xmPriceRange'){
      startDataVal.value=getNumberPrice(startDataVal.value,precision);
    }
    if(dateVal.value===null||dateVal.value===""){
      dateVal.value=0;
      unref(pModelObj)[unref(model).key]=0;
      nextTick(()=>{
        change.value=false;
      })
    }
  }

  const blurEndVal=function (){
    // 在 xmPriceRange 模式下，blurEndVal 专门处理结束值 endDataVal
    if(ctlType==='xmPriceRange'){
      // 验证 endDataVal
      if(isNaN(parseFloat(endDataVal.value))){
        endDataVal.value='0';
        return
      }
      endDataVal.value=parseFloat(endDataVal.value);

      // 超出范围时，限制在允许范围内
      const min = unref(props)?.min;
      const max = unref(props)?.max;
      if (min !== undefined && min !== null && endDataVal.value < min) {
        endDataVal.value = min;
      }
      if (max !== undefined && max !== null && endDataVal.value > max) {
        endDataVal.value = max;
      }

      endDataVal.value=getNumberPrice(endDataVal.value,precision);

      if(endDataVal.value===null||endDataVal.value===""){
        endDataVal.value='0';
        unref(pModelObj)[unref(model).key+"_le"]=0;
        nextTick(()=>{
          change.value=false;
        })
      }
    } else {
      // 非 xmPriceRange 模式，处理 dateVal（与 blurVal 逻辑相同）
      if(isNaN(parseFloat(dateVal.value))){
        dateVal.value=0;
        return
      }
      dateVal.value=parseFloat(dateVal.value);

      // 超出范围时，限制在允许范围内
      const min = unref(props)?.min;
      const max = unref(props)?.max;
      if (min !== undefined && min !== null && dateVal.value < min) {
        dateVal.value = min;
      }
      if (max !== undefined && max !== null && dateVal.value > max) {
        dateVal.value = max;
      }

      dateVal.value=getNumberPrice(dateVal.value,precision);

      if(dateVal.value===null||dateVal.value===""){
        dateVal.value=0;
        unref(pModelObj)[unref(model).key]=0;
        nextTick(()=>{
          change.value=false;
        })
      }
    }
  }


  if(unref(pModelObj)){
    //如果是后面设置值
    watch(() => unref(pModelObj)[unref(model).key], (newVal) => {
      if(newVal==null){
        dateVal.value='';
      }
      if (unref(change)) {
        return
      }
      change.value = true;
      dateVal.value=getNumberPrice(unref(pModelObj)[unref(model).key]||0,precision);
      nextTick(() => {
        change.value = false;
      })
    })
  }


  watch(dateVal, () => {
    if (unref(change)) {
      return
    }
    change.value = true;
    unref(pModelObj)[unref(model).key]=moneyToNumber(unref(dateVal));
    nextTick(() => {
      change.value = false;
    })
  })

  /**
   * 开始金额
   */
  watch(startDataVal, () => {
    if (unref(change)) {
      return
    }
    change.value = true;
    unref(pModelObj)[unref(model).key+"_ge"]=noMoneyFormat(unref(startDataVal));
    nextTick(() => {
      change.value = false;
    })
  })

  if(ctlType==='xmPriceRange'){
    watch(() => unref(pModelObj)[unref(model).key+"_ge"], () => {
      if (unref(change)) {
        return
      }
      change.value = true;
      startDataVal.value=getNumberPrice(unref(pModelObj)[unref(model).key+"_ge"]||0,precision);
      nextTick(() => {
        change.value = false;
      })
    })

    /**
     * 结束金额
     */
    watch(endDataVal, () => {
      if (unref(change)) {
        return
      }
      change.value = true;
      unref(pModelObj)[unref(model).key+"_le"]=noMoneyFormat(unref(endDataVal));
      nextTick(() => {
        change.value = false;
      })
    })

    watch(() => unref(pModelObj)[unref(model).key+"_le"], () => {
      if (unref(change)) {
        return
      }
      change.value = true;
      endDataVal.value=getNumberPrice(unref(pModelObj)[unref(model).key+"_le"]||0,precision);
      nextTick(() => {
        change.value = false;
      })
    })
  }

  onMounted(()=>{
    change.value = true;
    //如果必填 则初始化默认值，不然会不正确
    if(unref(props)&&unref(props).required){
      if(unref(pModelObj)[unref(model).key]==null){
        unref(pModelObj)[unref(model).key]="0";
        dateVal.value='0';
      }
    }
    nextTick(() => {
      change.value = false;
    })
  })

  return {
    focusEndVal,
    blurEndVal,
    endDataVal,
    startDataVal,
    focusVal,
    blurVal,
    dateVal
  }
}
